// Everything that must be live before the main bundle finishes downloading.
// Rendered ahead of the application entrypoint, so link clicks made while the
// 6MB bundle is still loading are intercepted by Turbo instead of falling
// through to full navigations.
import "@hotwired/turbo";
import "../lib/turbo_confirmation";
import { application } from "../controllers/application";
import ConfirmationController from "../controllers/confirmation_controller";

application.register("confirmation", ConfirmationController);
